// extracted by mini-css-extract-plugin
export default {"descricao":"EsqueceuSenha_descricao__W0zOy","botoes":"EsqueceuSenha_botoes__WhFVW"};